class A11y {
  static get theme() {
    return A11y.get('theme');
  }

  static set theme(value) {
    const val = typeof value === 'string' ? value : '';
    document.body.setAttribute('data-theme', val);
    return A11y.set('theme', val);
  }

  static get minFontSize() {
    return -2;
  }

  static get maxFontSize() {
    return 2;
  }

  static get fontSize() {
    return +A11y.get('font-size') || 0;
  }

  static set fontSize(value) {
    const n = +value || 0;

    if (n < A11y.minFontSize || n > A11y.maxFontSize) {
      return A11y.set('font-size', A11y.fontSize);
    }

    document.body.setAttribute('data-font-size', n);
    return A11y.set('font-size', n);
  }

  static get prefix() {
    return '@a11y';
  }

  static get(key) {
    return localStorage.getItem(`${A11y.prefix}/${key}`);
  }

  static set(key, val) {
    return localStorage.setItem(`${A11y.prefix}/${key}`, val);
  }
}

A11y.theme = localStorage.getItem(`${A11y.prefix}/theme`);

A11y.fontSize = localStorage.getItem(`${A11y.prefix}/font-size`);

window.A11y = A11y;

export default A11y;
